// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.incoming-call-overlay {
  position: fixed;
  top: 24px;
  right: 24px;
  z-index: 99999;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: auto;
  animation: slideInDown 0.35s cubic-bezier(0.16, 1, 0.3, 1);
}

@keyframes slideInDown {
  from {
    opacity: 0;
    transform: translateY(-20px) scale(0.96);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

.incoming-call-card {
  width: 320px;
  background: rgba(15, 23, 42, 0.95);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 20px;
  padding: 24px 20px;
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.7), 0 0 30px rgba(59, 130, 246, 0.2);
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  color: white;
}

.incoming-call-avatar-wrapper {
  position: relative;
  width: 76px;
  height: 76px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;
}

.incoming-call-avatar {
  width: 72px;
  height: 72px;
  border-radius: 50%;
  background: linear-gradient(135deg, #3b82f6, #8b5cf6);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.8rem;
  font-weight: 700;
  color: white;
  overflow: hidden;
  position: relative;
  z-index: 2;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.4);
}

.incoming-call-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.incoming-call-pulse-ring {
  position: absolute;
  inset: -6px;
  border-radius: 50%;
  border: 2px solid rgba(59, 130, 246, 0.8);
  animation: callPulse 1.8s ease-out infinite;
  z-index: 1;
}

.incoming-call-pulse-ring.delay {
  animation-delay: 0.9s;
}

@keyframes callPulse {
  0% {
    transform: scale(0.9);
    opacity: 0.9;
  }
  100% {
    transform: scale(1.6);
    opacity: 0;
  }
}

.incoming-call-info {
  margin-bottom: 20px;
}

.incoming-call-name {
  font-size: 1.15rem;
  font-weight: 700;
  color: #f8fafc;
  margin: 0 0 6px 0;
  letter-spacing: -0.01em;
}

.incoming-call-type {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  font-size: 0.82rem;
  color: #94a3b8;
}

.call-type-icon.video {
  color: #10b981;
}

.call-type-icon.voice {
  color: #3b82f6;
}

.incoming-call-actions {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 28px;
  width: 100%;
}

.call-action-btn {
  width: 52px;
  height: 52px;
  border-radius: 50%;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  transition: all 0.2s cubic-bezier(0.16, 1, 0.3, 1);
}

.call-action-btn.accept {
  background: linear-gradient(135deg, #10b981, #059669);
  box-shadow: 0 6px 20px rgba(16, 185, 129, 0.4);
}

.call-action-btn.accept:hover {
  transform: scale(1.1);
  box-shadow: 0 8px 24px rgba(16, 185, 129, 0.6);
}

.call-action-btn.decline {
  background: linear-gradient(135deg, #ef4444, #dc2626);
  box-shadow: 0 6px 20px rgba(239, 68, 68, 0.4);
}

.call-action-btn.decline:hover {
  transform: scale(1.1);
  box-shadow: 0 8px 24px rgba(239, 68, 68, 0.6);
}
`, "",{"version":3,"sources":["webpack://./src/components/IncomingCallModal/IncomingCallModal.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,SAAS;EACT,WAAW;EACX,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,0DAA0D;AAC5D;;AAEA;EACE;IACE,UAAU;IACV,wCAAwC;EAC1C;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;EACE,YAAY;EACZ,kCAAkC;EAClC,2BAA2B;EAC3B,mCAAmC;EACnC,2CAA2C;EAC3C,mBAAmB;EACnB,kBAAkB;EAClB,4EAA4E;EAC5E,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qDAAqD;EACrD,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,yCAAyC;EACzC,2CAA2C;EAC3C,UAAU;AACZ;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE;IACE,qBAAqB;IACrB,YAAY;EACd;EACA;IACE,qBAAqB;IACrB,UAAU;EACZ;AACF;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,kDAAkD;AACpD;;AAEA;EACE,qDAAqD;EACrD,8CAA8C;AAChD;;AAEA;EACE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,qDAAqD;EACrD,6CAA6C;AAC/C;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C","sourcesContent":[".incoming-call-overlay {\n  position: fixed;\n  top: 24px;\n  right: 24px;\n  z-index: 99999;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  pointer-events: auto;\n  animation: slideInDown 0.35s cubic-bezier(0.16, 1, 0.3, 1);\n}\n\n@keyframes slideInDown {\n  from {\n    opacity: 0;\n    transform: translateY(-20px) scale(0.96);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n.incoming-call-card {\n  width: 320px;\n  background: rgba(15, 23, 42, 0.95);\n  backdrop-filter: blur(20px);\n  -webkit-backdrop-filter: blur(20px);\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  border-radius: 20px;\n  padding: 24px 20px;\n  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.7), 0 0 30px rgba(59, 130, 246, 0.2);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  color: white;\n}\n\n.incoming-call-avatar-wrapper {\n  position: relative;\n  width: 76px;\n  height: 76px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 16px;\n}\n\n.incoming-call-avatar {\n  width: 72px;\n  height: 72px;\n  border-radius: 50%;\n  background: linear-gradient(135deg, #3b82f6, #8b5cf6);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.8rem;\n  font-weight: 700;\n  color: white;\n  overflow: hidden;\n  position: relative;\n  z-index: 2;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.4);\n}\n\n.incoming-call-avatar img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.incoming-call-pulse-ring {\n  position: absolute;\n  inset: -6px;\n  border-radius: 50%;\n  border: 2px solid rgba(59, 130, 246, 0.8);\n  animation: callPulse 1.8s ease-out infinite;\n  z-index: 1;\n}\n\n.incoming-call-pulse-ring.delay {\n  animation-delay: 0.9s;\n}\n\n@keyframes callPulse {\n  0% {\n    transform: scale(0.9);\n    opacity: 0.9;\n  }\n  100% {\n    transform: scale(1.6);\n    opacity: 0;\n  }\n}\n\n.incoming-call-info {\n  margin-bottom: 20px;\n}\n\n.incoming-call-name {\n  font-size: 1.15rem;\n  font-weight: 700;\n  color: #f8fafc;\n  margin: 0 0 6px 0;\n  letter-spacing: -0.01em;\n}\n\n.incoming-call-type {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  font-size: 0.82rem;\n  color: #94a3b8;\n}\n\n.call-type-icon.video {\n  color: #10b981;\n}\n\n.call-type-icon.voice {\n  color: #3b82f6;\n}\n\n.incoming-call-actions {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 28px;\n  width: 100%;\n}\n\n.call-action-btn {\n  width: 52px;\n  height: 52px;\n  border-radius: 50%;\n  border: none;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: white;\n  transition: all 0.2s cubic-bezier(0.16, 1, 0.3, 1);\n}\n\n.call-action-btn.accept {\n  background: linear-gradient(135deg, #10b981, #059669);\n  box-shadow: 0 6px 20px rgba(16, 185, 129, 0.4);\n}\n\n.call-action-btn.accept:hover {\n  transform: scale(1.1);\n  box-shadow: 0 8px 24px rgba(16, 185, 129, 0.6);\n}\n\n.call-action-btn.decline {\n  background: linear-gradient(135deg, #ef4444, #dc2626);\n  box-shadow: 0 6px 20px rgba(239, 68, 68, 0.4);\n}\n\n.call-action-btn.decline:hover {\n  transform: scale(1.1);\n  box-shadow: 0 8px 24px rgba(239, 68, 68, 0.6);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
